<template>
  <div class="page-wrapper">
      <common :goodsData="goodsData" :modify="true" :disabled="false" ></common>
  </div>
</template>
 
<script type="text/ecmascript-6">
import {readGoodsArchives} from 'api/archives'
import Common from './../components/Common'
export default {
  name:'addgoods',
  components:{
    Common
  },
  created(){
   if(this.goodsCode){
      readGoodsArchives({goodsArchivesCode: this.goodsCode}).then( res => {
        this.goodsData = res.data
      })
    }
  },
  computed:{
    goodsCode() {
      return this.$store.state.goodsArchives.modifyCode;
    }
  },
  data () {
    return {
      goodsData:{   
       goodsData:null
      }
    };
 }
}
</script>
